import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HideFromOrganizationMemberPipe } from './hide-from-organization-member.pipe';

@NgModule({
  declarations: [HideFromOrganizationMemberPipe],
  exports: [HideFromOrganizationMemberPipe, HideFromOrganizationMemberPipe],
  imports: [CommonModule],
})
export class HideFromOrganizationMemberModule {}
